import { __extends } from "tslib";
import { EventBase } from '@awayjs/core';
var ImageEvent = /** @class */ (function (_super) {
    __extends(ImageEvent, _super);
    /**
     * Create a new ImageEvent
     * @param type The event type.
     * @param image The instance of the image being updated.
     */
    function ImageEvent(type, image) {
        var _this = _super.call(this, type) || this;
        _this._image = image;
        return _this;
    }
    Object.defineProperty(ImageEvent.prototype, "image", {
        /**
         * The image of the material.
         */
        get: function () {
            return this._image;
        },
        enumerable: false,
        configurable: true
    });
    /**
     *
     */
    ImageEvent.INVALIDATE_MIPMAPS = 'invalidateMipmaps';
    return ImageEvent;
}(EventBase));
export { ImageEvent };
